import React from "react";
import { AppBar, Toolbar, Typography, Button } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout, clearViewAs } from "../containers/Auth/authSlice";

const Header = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { station, isAdmin, viewAsUid } = useSelector((state) => state.auth);

  const handleLogout = () => {
    dispatch(logout());
    localStorage.removeItem("userId");
    navigate("/login");
  };

  const handleBackToMenu = () => {
    dispatch(clearViewAs());
    navigate("/menu");
  };

  return (
    <AppBar position="static">
      <Toolbar className="mobile-pad">
        <Typography
          variant="h6"
          component="div"
          sx={{ flexGrow: 1 }}
          className="mobile-text-sm"
        >
          OIL MED {station && `- ${station}`}
        </Typography>
        {isAdmin && viewAsUid ? (
          <Button color="inherit" onClick={handleBackToMenu}>
            ← Menu
          </Button>
        ) : (
          <Button color="inherit" onClick={handleLogout}>
            Déconnexion
          </Button>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default Header;
